import React from 'react';

const TermsPage = () => (
	<div className="terms_content">
		<h1 className="terms_headline">Teilnahmebedingungen</h1>
		<h2 className="terms_subline">"ROXX-RACING"</h2>
		<h4>Stand 30. November 2018</h4>

		<div className="terms_list">
			<h3>1. Allgemein</h3>

			<p>1.1. Die Internetpräsenz Roxx-Racing (<a href="/">www.roxx-racing.com</a>) ist ein Teilbereich der Web-Community VISIT-X.net, betrieben durch die
				VISIT-X B.V., Krijn Taconiskade 424, 1087 HW Amsterdam, Niederlande, vertreten durch Maurice Berendsen (nachfolgend Bereitsteller genannt).
			</p>

			<p>1.2. Am Ende der Online-Veranstaltung besteht für registrierte Teilnehmer (Kunden), welche Gebotsrechte (Tickets) erworben haben, die
				Möglichkeit im Rahmen einer sogenannten ‚Cent-Auktion‘ einen PKW käuflich zu erwerben. Dieser wird im Rahmen der Online-Veranstaltung
				von einer gebrauchten Werksversion bis zu einem sogenannten Tuning-Fahrzeug durch diverse technische und optische Veränderungen aufgebaut.
				Veranstalter der ‚Cent-Auktion‘ ist die VISIT-X GmbH, Dr.-Hermann-Neubauer-Ring-32 in 63500 Seligenstadt, Amtsgericht Offenbach a. M.,
				HRB 41768 (nachfolgend <b>Veranstalter</b> der Online-Veranstaltung genannt).
			</p>

			<p>1.3. Die Online-Veranstaltung sowie die ‚Cent-Auktion‘ dienen der Generierung von Spenden zugunsten eines oder mehreren wohltätigen
				Vereinen. Der Bereitsteller und der Veranstalter der Online-Veranstaltung verpflichten sich, alle Einnahmen aus dem Verkauf von
				Gebotsrechten und sonstigen medialen Inhalten, wie z. B. Filmen, nach Abzug einer Pauschale in Höhe von 10% für den Betrieb und
				Durchführung der Online-Veranstaltung, zu spenden.
			</p>

			<p>1.4. Die Durchführung der einzelnen Tuning-Maßnahmen zur Veredelung des PKW, sowie die Bestimmungen der Spendenempfänger erfolgen
				im Dialog mit den Teilnehmern und der sogenannten Community, z. B. über Online-Votings oder andere Meinungserhebungen.
			</p>

			<p>1.5. Die Ermittlung der Gewinner und Spendensumme sowie die Zuwendung der Spendensumme an einen oder mehrere wohltätige Vereine,
				erfolgt unter Aufsicht des Notariats Krayer & Kollegen, Seligenstadt.
			</p>

			<p>1.6. Soweit bei der Online-Veranstaltung Roxx-Racing ein Dritter (Händler/Hersteller) als diejenige Partei genannt wird, welche die
				an dem PKW zu verbauende Ware zur Verfügung stellt (Qualitätsveredelung), handelt es sich hierbei um den Lieferanten des Veranstalters
				Online-Veranstaltung. Im Rahmen des Kaufs des PKW bleibt der Veranstalter der Online-Veranstaltung Vertragspartner des Kunden und
				behält sich vor, bei der Vertragserfüllung einen anderen gleichwertigen Lieferanten einzusetzen.
			</p>

			<p>1.7. Die Online-Veranstaltung beginnt am 1. Dezember 2018 und endet am 12. Dezember 2019.</p>

			<p>1.8. Der Bereitsteller behält sich das Recht vor, das Projekt zu jedem Zeitpunkt ohne Vorankündigung und ohne Angabe von Gründen
				abzubrechen oder zu beenden. Von dieser Möglichkeit macht der Bereitsteller insbesondere dann Gebrauch, wenn aus technischen Gründen
				(z. B. Viren im Computersystem, Manipulation oder Fehler in der Hard- und/ oder Software) oder aus rechtlichen Gründen eine
				ordnungsgemäße Durchführung des Projektes nicht gewährleistet werden kann. Sofern eine derartige Beendigung durch das Verhalten
				eines Teilnehmers verursacht wird, kann der Bereitsteller von dieser Person den entstandenen Schaden ersetzt verlangen, wenn aus
				technischen oder rechtlichen Gründen eine ordnungsgemäße Durchführung nicht gewährleistet werden kann.
			</p>

			<h3>2. Teilnahmeberechtigung</h3>

			<p>2.1. Zur Teilnahme an der Online-Veranstaltung und der abschließenden ‚Cent-Auktion‘ sind nur Verbraucher im Sinne des BGB, die
				über 18 Jahre alt und unbeschränkt geschäftsfähig sind und ihren Hauptwohnsitz in der Bundesrepublik Deutschland, Österreich oder der
				Schweiz unterhalten.
			</p>

			<p>2.2. Die Teilnahme erfolgt mit Registrierung in der Webcommunity VISIT-X.net und anschließender Bestätigung der Teilnahmebedingungen.</p>

			<p>2.3. Nicht zur Teilnahme berechtigt sind juristische Personen und solche natürlichen Personen, welche in einem mindestens
				Dienstleistungsverhältnis zum Bereitsteller und/ oder Veranstalter der Online-Veranstaltung stehen. Ebenfalls nicht zur Teilnahme
				berechtigt, sind solche natürlichen Personen, welche sich einen Wohnsitz mit einem der ausgeschlossenen Personen teilen.
			</p>

			<p>2.4. Je Haushalt und postalischer Adresse ist lediglich ein Kundenkonto zulässig</p>

			<p>2.5. Der Veranstalter der Online-Veranstaltung behält sich das Recht vor, einen Kunden von der Teilnahme an der Online-Veranstaltung
				Roxx-Racing ganz oder zeitweilig auszuschließen und alle hierfür erforderlichen Maßnahmen zu treffen, wenn
			</p>

			<p>dieser gegen die allgemeinen Geschäftsbedingungen verstößt,</p>

			<p>dieser gegen straf- und ordnungsrechtliche Vorschriften verstößt,</p>

			<p>dieser die abschließende Auktion des Eigentümers indirekt manipuliert (z. B. durch den Einsatz nicht autorisierter Bietsoftware),</p>

			<p>dieser den Auktionsdienst des Eigentümers direkt manipuliert (z. B. durch das Anlegen und/ oder Steuern mehrerer Kundenkonten
				oder das Vornehmen unfairer oder betrügerischer Absprachen mit anderen Kunden des Veranstalters der Online-Veranstaltung),
			</p>

			<p>dieser einen Nutzernamen verwendet, der gegen die guten Sitten verstößt, die Rechte Dritter verletzt oder die Gefahr eröffnet,
				den Auktionsablauf zu stören,
			</p>

			<p>dieser die Abstimmungen der Online-Community Roxx-Racing manipulativ (unmittelbar oder mittelbar) beeinflusst oder</p>

			<p>das Kundenkonto des Kunden von einem Dritten missbraucht wird.</p>

			<h3>3. Änderung der AGB </h3>

			<p>3.1. Die Bereitsteller und Veranstalter der Online-Veranstaltung behalten sich das Recht vor, diese Bedingungen in
				Zukunft mit einer Frist von 7 Tagen zu ändern. Die Benachrichtigung per E-Mail ist ausreichend. Akzeptiert der Teilnehmer die
				neuen Teilnahmebedingungen nicht, kann er seine Teilnahme kündigen und hat Anrecht auf Rückerstattung für sowohl bereits
				eingesetzte als auch noch unverbrauchte Tickets.
			</p>

			<h3>4. Registrierung und Teilnahme</h3>

			<p>
				4.1. Die Teilnahme an der Online-Veranstaltung Roxx-Racing und der abschließenden ‚Cent-Auktion‘, ist registrierten Kunden der
				Web-Community VISIT-X.net vorbehalten.
			</p>

			<p>4.2. Die Teilnahme setzt weiterhin voraus, dass der Teilnehmer die vorliegenden Teilnahmebedingungen akzeptiert.</p>

			<p>4.3. Sofern noch keine Registrierung auf VISIT-X.net vorliegt, erfolgt diese über den blauen Button (1) ‚KOSTENLOS ANMELDEN‘
				rechts oben auf der Startseite von <a href="/">www.roxx-racing.com</a>.
			</p>

			<p>4.4. Danach ist die kostenlose Registrierung abgeschlossen und ein Benutzerkonto (Mitgliedskonto) angelegt, welches zur Teilnahme berechtigt.</p>

			<p>4.5. Kunden die bereits über ein Benutzerkonto auf VISIT-X.net verfügen, benötigen keine erneute Registrierung.</p>

			<h3>5. Kauf von Gebotsrechten</h3>

			<p>5.1. Um an der ‚Cent-Auktion‘ zum Erwerb des PKW als Kunde teilnehmen zu können, müssen Gebotsrechte (Tickets) gekauft werden.
				Mit dem Erwerb eines Tickets erhält der Kunde die Möglichkeit zur Abgabe eines Gebots (Rechtskauf). Ein Ticket in Höhe von 0,50 €
				berechtigt zur Abgabe eines Gebots bei der abschließenden ‚Cent-Auktion‘. Nach Abgabe eines Gebots hat der Kunde die Möglichkeit
				den PKW zu erwerben, sofern er der Letztbietende ist und nicht ein anderer Kunde ein weiteres Gebot abgegeben hat. Bei dieser
				Auktion handelt es sich um einen Verkauf gegen Höchstgebot und nicht um eine Versteigerung im Sinne des § 156 BGB. Dies bedeutet,
				dass im Anschluss an das Höchstgebot der PKW an den Kunden mit dem letzten Gebot verkauft wird.
			</p>

			<p>5.2. Die Gebotsrechte können einzeln oder in Paketform (in Verbindung mit anderen Waren) im Benutzerkonto Menü unter dem Punkt
				‚TICKETS‘ gekauft werden. Der Teilnehmer hat die Wahl zwischen mehreren Paketen. Es gelten die jeweils auf der Webseite genannten
				Konditionen. Der Anbieter behält sich vor, die Pakete im Laufe der Auktion zu modifizieren. <b>Ein bereits gekauftes Paket verliert
					dabei nicht seine Gültigkeit.</b> Der Kauf eines einzelnen Tickets zu Euro 0,50 ist möglich.
			</p>

			<p>5.3. Die Präsentation der Wahlmöglichkeiten zum Erwerb eines Paketes oder eines Einzeltickets, stellt seitens des Veranstalters der
				Online-Veranstaltung ein verbindliches Angebot zum Abschluss eines Kaufvertrags dar. Die Annahme des Angebots erfolgt seitens des
				Teilnehmers durch Setzung eines (1) Häkchens vor der entsprechenden Wahlmöglichkeit. Sobald der Teilnehmer durch Setzung eines
				weiteren (2) Häkchens eingewilligt hat, dass er damit einverstanden ist, dass die vom Bereitsteller gespeicherten und verarbeiteten
				Daten im Rahmen der Durchführung der ‚Cent-Auktion‘ an den Veranstalter der Online-Veranstaltung weitergegeben werden dürfen, ist
				im nachfolgenden Schritt durch (3) Klicken auf den blauen Button ‚Jetzt kaufen‘, die Zahlungsvariante zu wählen.
			</p>

			<p>5.4. Der Teilnehmer kann sein Einverständnis jederzeit gegenüber dem Bereitsteller unter der E-Mail Adresse <a href="mailto:support@visit-x.net">support@visit-x.net</a>
				widerrufen. Die Daten werden darüber hinaus vom Veranstalter der Online-Veranstaltung nicht für Werbezwecke genutzt und nach
				Auktionsende von diesem wieder gelöscht. Es gilt die Datenschutzerklärung des Bereitstellers.
			</p>

			<p>5.5. Die Zahlungsabwicklung für das Ticket erfolgt unter den Bedingungen für die Plattform RoxxRacing. <a href="https://www.visit-x.net/de/agb/" rel="noopener noreferrer" target="_blank">https://www.visit-x.net/de/agb/</a>
			</p>

			<h3>6. Widerruf </h3>

			<p>6.1. Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen den Vertrag zu widerrufen. Um Ihr Widerrufsrecht auszuüben, müssen Sie dem Bereitsteller:</p>

			<p>
				<b>VISIT-X B.V.</b><br />
				Krijn Taconiskade 424<br />
				NL-1087 HW Amsterdam<br />
				<b>E-Mail:</b> <a href="mailto:support@visit-x.net">support@visit-x.net</a><br />
				<b>Telefon:</b> 00 800 300 000 77
			</p>

			<p>
				mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief, Telefax oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren.
			</p>

			<p>
				6.2. Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
			</p>

			<p>6.3. Sie können Ihre kostenlose Mitgliedschaft jederzeit kündigen.</p>


			<p>6.4. Bei Widerruf dieses Vertrages, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, unverzüglich und spätestens
				binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf bei uns eingegangen ist. Für diese
				Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben.
			</p>


			<h3>7. Rückgabe von Geboten</h3>

			<p>7.1. Eine Rückgabe der Gebote und die Erstattung des Kaufpreises sind nur dann möglich, wenn die Gebote zum Preis von 0,50 € erworben wurden. </p>

			<p>7.2. Eine Rückgabe ist insbesondere dann nicht möglich, wenn:</p>

			<p>die Gebote bereits zum Bieten verwendet wurden,</p>

			<p>der Teilnehmer die Gebote kostenlos, durch Gutscheine oder sonstige Promotionen erhalten hat.</p>

			<p>Gebote die länger als der angegebene Veranstaltungszeitraum nicht zum Bieten verwendet wurden und deshalb verfallen sind.</p>

			<p>7.3. Der Kunde hat in keinem Fall Anspruch auf Erstattung eines höheren Betrags, als den Betrag, den er insgesamt für den Erwerb der Gebotsrechte bezahlt hat.</p>

			<p>
				<b>
					7.4. Für die Rückabwicklung von käuflich erworbenen Gebotspunkten (Tickets) nach Ablauf der Widerrufsmöglichkeit erhebt der
					Anbieter eine Gebühr von Euro 5,00. Insofern macht der Anbieter ausdrücklich darauf aufmerksam, dass eine Rückgabe nur bei einer
					größeren Menge an Gebotspunkten wirtschaftlich ist.
				</b>
			</p>

			<h3>8. Das Bieten / Abgabe von Geboten</h3>

			<p>8.1. Bei der finalen Auktion handelt es sich um einen Verkauf gegen Höchstgebot und nicht um eine Versteigerung im Sinne des § 156 BGB.</p>

			<p>
				8.2. Die Präsentation des PKW zum Zeitpunkt der Verkaufseinstellung auf <a href="/">www.roxx-racing.com</a> stellt ein Angebot auf Abschluss eines
				verbindlichen Kaufvertrags über eben diesen PKW dar. Dieses Angebot setzt jedoch voraus, dass der Kunde das letzte Gebot setzt, bis
				die Zeit der jeweiligen Auktion abgelaufen ist.

			</p>

			<p>8.3. Der Abschluss des Kaufvertrags über den PKW erfolgt nach gewonnener Auktion durch die Bezahlung des entsprechenden Kaufpreises durch den Kunden.</p>

			<p>8.4. Der Erwerb von Gebotspunkten ist ab dem 30.11.2018 möglich. Der Start der ‚Cent-Auktion‘ wird vom Bereitsteller durch Veröffentlichung
				auf der Homepage und durch Ankündigung per E-Mail, mindestens 7 Tage vor Start der Auktion bekannt gegeben.
			</p>

			<p>8.5. Um an der abschließenden Auktion auf <a href="/">www.roxx-racing.com</a> teilzunehmen, ist ein Gebot zu verwenden. Dieses geschieht durch Klick
				auf den zur Auktion gehörenden ‚Bieten‘-Button. Das Gebot wird hiermit unmittelbar gesetzt, vom Konto des Kunden abgezogen und der
				Kunde als Höchstbietender angezeigt. </p>

			<p>8.6. Die Dauer der Auktion verlängert sich dadurch um 30 Sekunden. Das Abgeben eines Gebots ist nur möglich, wenn der Kunde zu diesem
				Zeitpunkt noch nicht Höchstbietender ist. </p>

			<p>8.7. Beim Bieten werden immer zuerst die unbenutzten Gebote verwendet, die zum Preis von Euro 0,50 gekauft wurden. </p>

			<p>8.8. Eine Erstattung des Kaufpreises für diese Gebote ist nach der Verwendung zum Bieten nicht mehr möglich. </p>


			<h3>9. Gegenwert / Prinzip der Wohltätigkeit</h3>

			<p>9.1. Der Gegenwert bereits verbrauchter Gebote, welche nicht zum Kaufvertrag führen, liegt in dem Gedanken der Wohltätigkeit. </p>

			<h3>10. Verfall von Geboten</h3>

			<p>10.1. Gebote müssen innerhalb des Veranstaltungszeitraum verwendet werden. </p>

			<p>10.2. Dies gilt sowohl für Gebote, die gekauft wurden, als auch für Gebote die dem Teilnehmer kostenlos gutgeschrieben wurden.
				Nicht verwendete Gebote werden nach Beendigung der Auktion nicht zurückerstattet und von dem Kundenkonto entfernt.</p>

			<h3>11. Durchführbarkeit der Auktion und Änderung der Regularien</h3>

			<p>
				11.1. Um die Durchführbarkeit der Auktion zu gewährleisten, behält sich der Veranstalter der Online-Veranstaltung vor, die
				Regularien für alle Teilnehmer nach vorheriger Ankündigung durch Veröffentlichung auf der Homepage und durch Ankündigung per E-Mail,
				mindestens 7 Tage vor Start der Auktion bekannt zu gegeben. Dies kann zum Beispiel nötig werden, sollte aufgrund von zu vielen
				Geboten der Endzeitpunkt der Auktion über den von Veranstalter der Online-Veranstaltung genannten Endzeitpunkt hinausgehen.
			</p>

			<h3>12. Abwicklung des PKW Kaufvertrags</h3>

			<p>
				12.1. Der Käufer wird zeitnah über eine gesonderte E-Mail über die von ihm übermittelte E-Mail-Adresse über den Kauf informiert.
				Der Käufer wird gegebenenfalls aufgefordert, seine Identität entsprechend nachzuweisen, bevor er als Käufer bestätigt werden kann.
				Wird der Käufer nicht erreicht oder meldet sich der Käufer nicht innerhalb von zwei Wochen nach Versenden der Benachrichtigung per
				E-Mail oder ist die Benachrichtigung unzustellbar verfällt der Anspruch auf die Übergabe und Übereignung des PKW und es wird der
				Zweithöchstbietende über eine gesonderte E-Mail über die von ihm übermittelte E-Mail-Adresse über den Kauf informiert.
			</p>

			<p>
				12.2. Ist auch dieser Käufer innerhalb von zwei Wochen nach Versenden der Benachrichtigungs-E-Mail nicht zu erreichen verfällt
				das Angebot endgültig.
			</p>

			<p>
				12.3. Für die Richtigkeit der angegebenen E-Mail-Adresse ist der Teilnehmer verantwortlich. Der Bereitsteller ist nicht
				verpflichtet richtige E-Mail-Adressen zu ermitteln.
			</p>

			<p>
				12.4. Der PKW ist vom Umtausch ausgeschlossen. Eine Auszahlung des Gewinns anders als bestimmt, z. B. in bar, in Sachwerten,
				deren Tausch oder Übertragung auf andere Personen ist nicht möglich.
			</p>

			<p>
				12.5. Auf Grund der Beschaffenheit des PKW sind Gewährleistungsansprüche nach Gefahrübergabe an den Käufer ausgeschlossen.
				Eine Garantie wird nicht gegeben.
			</p>

			<p>
				12.6. Dem Käufer werden die Kontaktdaten der für die Aushändigung des PKW zuständigen Abholstelle genannt.
			</p>

			<p>
				12.7. Wird der Gewinn nicht innerhalb der vom Veranstalter der Online-Veranstaltung bestimmten Frist von der
				mitgeteilten Stelle abgeholt, verfällt der Anspruch auf Übergabe und Übereignung.
			</p>

			<p>
				12.8. Alle Kosten, welche durch die Abholung verursacht werden, sowie alle weiteren Folgekosten (Steuern, Kraftstoff,
				Reparaturen etc.) trägt der Käufer. Auf den Gewinn gibt es keinen Gewährleistungs- oder Garantieanspruch.
			</p>

			<h3>13. Salvatorische Klausel </h3>

			<p>13.1. Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, so wird dadurch die Rechtmäßigkeit der übrigen
				Bestimmungen nicht berührt. An ihre Stelle tritt eine angemessene Regelung, die dem Zweck der unwirksamen Bestimmung am
				ehesten entspricht. </p>


			<h3>14. Rechtsstand</h3>

			<p>
				14.1. Es gilt deutsches Recht. Gerichtsstand ist - soweit zulässig – für alle sich im Zusammenhang mit der Aktion ergebenden
				Streitigkeiten ist Offenbach am Main.
			</p>
		</div>

		<div>
			<a href="/tickets" rel="noopener norefferrer" className="terms_back">
				<div className="terms_back-button">Zurück</div>
			</a>
		</div>

	</div>
);

export default TermsPage;


// WEBPACK FOOTER //
// ./src/TermsPage.js